var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPractice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#494848;}.cls-3{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "practice"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.54,8.15c0-3.95-2.95-7.15-6.6-7.15h-.26v7.31h-7.36V1h-.26c-3.65,0-6.6,3.2-6.6,7.15,0,.06,0,.13,0,.19,0,.06,0,.13,0,.19,0,3.95,2.95,7.15,6.6,7.15h.25v7.31h7.43v-7.31h.2c3.65,0,6.6-3.2,6.6-7.15,0-.06,0-.13,0-.19,0-.06,0-.13,0-.19Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPractice);
export default __webpack_public_path__ + "static/media/icon_practice.8477d122cc0603f21dc74a67e45f0b4f.svg";
export { ForwardRef as ReactComponent };